import { render, staticRenderFns } from "./workOrderStatistic.vue?vue&type=template&id=03a84f84&scoped=true&"
import script from "./workOrderStatistic.vue?vue&type=script&lang=js&"
export * from "./workOrderStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a84f84",
  null
  
)

export default component.exports